export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '07d8ba10-ae7b-4d69-b0da-280b4fc29e98';
export const MODAL_CLOSE_SEC = 2.5;
